import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosForecastInstance as axios } from "axios.js";
import { axiosRiskInstance as axiosRiskInstance } from "axios.js";
import { dummyUsageData } from "./dummyAssetUsageData";

const initialState = {
  usageData: {
    dropDownListItems: {
      markets: ["ERCOT"],
      zones: ["HOUSTON", "NORTH", "SOUTH", "WEST"],
      books: [
        "Residential Fixed",
        "Residential Variable",
        "Commercial Fixed",
        "Commercial Variable",
      ],
    },
    loader: false,
  },
  usageChartData: {
    block_types: [],
    list: [] /*dummyUsageData.data*/,
    loader: false,
  },
  revenueData: {
    dropDownListItems: {
      markets: ["ERCOT"],
      zones: ["HOUSTON", "NORTH", "SOUTH", "WEST"],
      books: [
        "Residential Fixed",
        "Residential Variable",
        "Commercial Fixed",
        "Commercial Variable",
      ],
    },
    loader: false,
  },
  revenueChartData: {
    block_types: [],
    list: [] /*dummyUsageData.data*/,
    loader: false,
  },
  revenueDataV2: {
    dropDownListItems: {
      markets: [],
      zones: [],
      books: [],
      years: [],
    },
    loader: false,
  },
  revenueChartDataV2: { list: [], loader: false },
  usageDataV2: {
    dropDownListItems: {
      markets: [],
      zones: [],
      books: [],
      years: [],
    },
    loader: false,
  },
  usageChartDataV2: { list: [], loader: false },
};

export const getAssetUsageRevenueV2Async = createAsyncThunk(
  "asset/get/usagerevenuev2",
  async (dropDownListItems) => {
    // Build query parameters from dropDownListItems
    const queryParams = new URLSearchParams();

    // Add markets if they exist and are not empty
    if (dropDownListItems.markets && dropDownListItems.markets.length > 0) {
      dropDownListItems.markets.forEach((market) => {
        queryParams.append("market", market);
      });
    }

    // Add zones if they exist and are not empty
    if (dropDownListItems.zones && dropDownListItems.zones.length > 0) {
      dropDownListItems.zones.forEach((zone) => {
        queryParams.append("zone", zone);
      });
    }

    // Add books if they exist and are not empty
    if (dropDownListItems.books && dropDownListItems.books.length > 0) {
      dropDownListItems.books.forEach((book) => {
        queryParams.append("book", book);
      });
    }

    // Add years if they exist and are not empty
    if (dropDownListItems.years && dropDownListItems.years.length > 0) {
      dropDownListItems.years.forEach((year) => {
        queryParams.append("year", year);
      });
    }

    // Construct the URL with query parameters
    const baseUrl = "/api/v2/asset_valuation/get_usage_and_revenue_data_v2";
    const urlWithParams = queryParams.toString()
      ? `${baseUrl}?${queryParams.toString()}`
      : baseUrl;

    const response = await axiosRiskInstance.get(urlWithParams);
    return response;
  }
);

export const getAssetUsageRevenueAsync = createAsyncThunk(
  "asset/get/usagerevenue",
  async (body) => {
    const response = await axios.get(
      "/api/v1/get_usage_and_revenue_data",
      body
    );
    return response;
  }
);

export const getAssetUsageAsync = createAsyncThunk(
  "asset/get/usage",
  async (body) => {
    const response = await axios.get("/api/v1/get_usage_map", body);
    return response;
  }
);

export const getAssetRevenueAsync = createAsyncThunk(
  "asset/get/revenue",
  async (body) => {
    const response = await axios.get("/api/v1/get_revenue_map", body);
    return response;
  }
);
export const getAssetUsageV2Async = createAsyncThunk(
  "asset/get/usagev2",
  async (dropDownListItems) => {
    // Build query parameters from dropDownListItems
    const queryParams = new URLSearchParams();

    // Add markets if they exist and are not empty
    if (dropDownListItems.markets && dropDownListItems.markets.length > 0) {
      dropDownListItems.markets.forEach((market) => {
        queryParams.append("market", market);
      });
    }

    // Add zones if they exist and are not empty
    if (dropDownListItems.zones && dropDownListItems.zones.length > 0) {
      dropDownListItems.zones.forEach((zone) => {
        queryParams.append("zone", zone);
      });
    }

    // Add books if they exist and are not empty
    if (dropDownListItems.books && dropDownListItems.books.length > 0) {
      dropDownListItems.books.forEach((book) => {
        queryParams.append("book", book);
      });
    }

    // Add years if they exist and are not empty
    if (dropDownListItems.years && dropDownListItems.years.length > 0) {
      dropDownListItems.years.forEach((year) => {
        queryParams.append("year", year);
      });
    }

    // Construct the URL with query parameters
    const baseUrl = "/api/v2/asset_valuation/get_usage_and_revenue_data_usage_v2";
    const urlWithParams = queryParams.toString()
      ? `${baseUrl}?${queryParams.toString()}`
      : baseUrl;

    const response = await axiosRiskInstance.get(urlWithParams);
    return response;
  }
);
export const assetUsageSlice = createSlice({
  name: "asset/usage/slice",
  initialState,
  reducers: {
    zoneOnChange: (state, action) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAssetUsageAsync.pending, (state) => {
        //state.usageData.loader = true;
        state.usageChartData.loader = true;
      })
      .addCase(getAssetUsageAsync.fulfilled, (state, action) => {
        //state.usageData.loader = false;
        //state.usageData.dropdownList = action?.payload?.data || [];

        state.usageChartData.loader = false;
        state.usageChartData.list = action?.payload?.data.data || [];
        state.usageChartData.block_types =
          action?.payload?.data.block_types || [];
      })
      .addCase(getAssetUsageAsync.rejected, (state, action) => {
        //state.usageData.loader = false;
        //state.usageData.dropdownList = [];

        state.usageChartData.loader = false;
        state.usageChartData.list = [];
        state.usageChartData.block_types = [];
      })
      .addCase(getAssetRevenueAsync.pending, (state) => {
        //state.revenueData.loader = true;
        state.revenueChartData.loader = true;
      })
      .addCase(getAssetRevenueAsync.fulfilled, (state, action) => {
        //state.revenueData.loader = false;
        //state.revenueData.dropdownList = action?.payload?.data || [];

        state.revenueChartData.loader = false;
        state.revenueChartData.list = action?.payload?.data.data || [];
        state.revenueChartData.block_types =
          action?.payload?.data.block_types || [];
      })
      .addCase(getAssetRevenueAsync.rejected, (state, action) => {
        //state.revenueData.loader = false;
        //state.revenueData.dropdownList = [];

        state.revenueChartData.loader = false;
        state.revenueChartData.list = [];
        state.revenueChartData.block_types = [];
      })
      .addCase(getAssetUsageRevenueAsync.pending, (state) => {
        //state.revenueData.loader = true;
        state.revenueChartData.loader = true;
        state.usageChartData.loader = true;
      })
      .addCase(getAssetUsageRevenueAsync.fulfilled, (state, action) => {
        //state.revenueData.loader = false;
        //state.revenueData.dropdownList = action?.payload?.data || [];

        state.usageChartData.loader = false;
        state.usageChartData.list = action?.payload?.data.data || [];
        state.usageChartData.block_types =
          action?.payload?.data.block_types || [];

        state.revenueChartData.loader = false;
        state.revenueChartData.list = action?.payload?.data.data || [];
        state.revenueChartData.block_types =
          action?.payload?.data.block_types || [];
      })
      .addCase(getAssetUsageRevenueAsync.rejected, (state, action) => {
        //state.revenueData.loader = false;
        //state.revenueData.dropdownList = [];

        state.usageChartData.loader = false;
        state.usageChartData.list = [];
        state.usageChartData.block_types = [];

        state.revenueChartData.loader = false;
        state.revenueChartData.list = [];
        state.revenueChartData.block_types = [];
      })
      .addCase(getAssetUsageRevenueV2Async.pending, (state) => {
        state.revenueChartDataV2.loader = true;
        state.revenueDataV2.loader = true;
      })
      .addCase(getAssetUsageRevenueV2Async.fulfilled, (state, action) => {
        state.revenueChartDataV2.loader = false;
        state.revenueChartDataV2.list = action?.payload?.data.data || [];

        state.revenueDataV2.loader = false;
        if (state.revenueDataV2.dropDownListItems.markets.length === 0)
          state.revenueDataV2.dropDownListItems.markets =
            action?.payload?.data?.filters?.markets || [];

        if (state.revenueDataV2.dropDownListItems.zones.length === 0)
          state.revenueDataV2.dropDownListItems.zones =
            action?.payload?.data?.filters?.zones || [];

        if (state.revenueDataV2.dropDownListItems.books.length === 0)
          state.revenueDataV2.dropDownListItems.books =
            action?.payload?.data?.filters?.books || [];

        if (state.revenueDataV2.dropDownListItems.years.length === 0)
          state.revenueDataV2.dropDownListItems.years =
            action?.payload?.data?.filters?.years || [];
      })
      .addCase(getAssetUsageRevenueV2Async.rejected, (state, action) => {
        state.revenueChartDataV2.loader = false;
        state.revenueDataV2.loader = false;
        state.revenueChartDataV2.list = [];
      }) 
      .addCase(getAssetUsageV2Async.pending, (state) => {
        state.usageChartDataV2.loader = true;
        state.usageDataV2.loader = true;
      })
      .addCase(getAssetUsageV2Async.fulfilled, (state, action) => {
        state.usageChartDataV2.loader = false;
        state.usageChartDataV2.list = action?.payload?.data.data || [];

        state.usageDataV2.loader = false;
        if (state.usageDataV2.dropDownListItems.markets.length === 0)
          state.usageDataV2.dropDownListItems.markets =
            action?.payload?.data?.filters?.markets || [];

        if (state.usageDataV2.dropDownListItems.zones.length === 0)
          state.usageDataV2.dropDownListItems.zones =
            action?.payload?.data?.filters?.zones || [];

        if (state.usageDataV2.dropDownListItems.books.length === 0)
          state.usageDataV2.dropDownListItems.books =
            action?.payload?.data?.filters?.books || [];

        if (state.usageDataV2.dropDownListItems.years.length === 0)
          state.usageDataV2.dropDownListItems.years =
            action?.payload?.data?.filters?.years || [];
      })
      .addCase(getAssetUsageV2Async.rejected, (state, action) => {
        state.usageChartDataV2.loader = false;
        state.usageDataV2.loader = false;
        state.usageChartDataV2.list = [];
      });
  },
});
export const { zoneOnChange } = assetUsageSlice.actions;
// Action creators are generated for each case reducer function
export default assetUsageSlice.reducer;
